import type { HackerEntryDashboard } from '@/types';
import { NoActiveParticipation } from './components/NoActiveParticipation';

// GET /hacker/dashboard for a hacker with no accepted submission in the current event.
// Everyone else was redirected into their edition's dashboard by the controller.
export default function Dashboard({ userName }: HackerEntryDashboard) {
  return <NoActiveParticipation userName={userName} />;
}
